// extracted by mini-css-extract-plugin
export default {"container":"LoaderSkeleton_container__AtGrE","leftOffset":"LoaderSkeleton_leftOffset__8RNpo","row":"LoaderSkeleton_row__l2UeA","img":"LoaderSkeleton_img__DqeMa"};